import { z } from 'zod'

import mxTranslations from '../i18n/messages/es-MX.json'

/**
 * password validate schema
 * 提供给需要密码验证规则使用
 */
export const passwordValidateSchema = z.object({
  password: z
    .string()
    .trim()
    .superRefine((val, ctx) => {
      const checks = [
        {
          test: val.length >= 8,
          message: mxTranslations?.Common?.pass_val_rule_one || 'At least 8 characters.',
          code: 'min-length',
        },
        {
          test: /\d/.test(val),
          message: mxTranslations?.Common?.pass_val_rule_two || 'Must contain at least one number.',
          code: 'number',
        },
        {
          test: /[a-z]/.test(val),
          message: mxTranslations?.Common?.pass_val_rule_three || 'Must contain at least 1 lowercase letter.',
          code: 'lowercase',
        },
        {
          test: /[A-Z]/.test(val),
          message: mxTranslations?.Common?.pass_val_rule_four || 'Must contain at least one uppercase letter.',
          code: 'uppercase',
        },
        {
          test: /[^a-zA-Z0-9]/.test(val),
          message: mxTranslations?.Common?.pass_val_rule_five || 'Must contain at least one special symbol.',
          code: 'symbol',
        },
      ]

      checks.forEach(
        ({
          test,
          message,
          // code
        }) => {
          if (!test) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message,
              // path: [code], // 使用 code 作为错误路径标识
            })
          }
        },
      )
    }),
})
